import { ProtectedRoute, RouteError } from '@cks-internal/react-base';
import { createBrowserRouter } from 'react-router-dom';
import { MainLayout } from 'src/components/Layout/MainLayout';
import { AllAccessRoles, ApplicationRoles } from 'src/constants/appRoles';
import { Home } from 'src/features/misc/Home';
import { PageNotFound } from 'src/features/misc/PageNotFound';
import { AuthorizedRoutes } from './AuthorizedRoutes';
import { ApprovalRoutes, UnauthorizedRoutes } from './UnauthorizedRoutes';
import { RedirectToLogin } from './RedirectToLogin';
import { NoNavLayout } from 'src/components/Layout/NoNavLayout.tsx';

export const FrontierRoutes = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        Component: Home
      }
    ],
    errorElement: <RouteError />
  },
  {
    path: '/',
    element: <MainLayout />,
    children: UnauthorizedRoutes,
    errorElement: <RouteError />
  },
  {
    path: '/',
    element: <NoNavLayout />,
    children: ApprovalRoutes,
    errorElement: <RouteError />
  },
  {
    path: '/',
    element: (
      <ProtectedRoute
        accessDeniedOverride={<RedirectToLogin />}
        allowedRoles={[...AllAccessRoles, ApplicationRoles.reservations, ApplicationRoles.obtUser]}>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: AuthorizedRoutes,
    errorElement: <RouteError />
  },

  //404
  {
    path: '*',
    element: <MainLayout />,
    children: [
      {
        path: '*',
        element: <PageNotFound />
      }
    ],
    errorElement: <RouteError />
  }
]);
